import IconButton from '@material-ui/core/IconButton';
import { Menu, MenuItem, Button } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const MenuContainer = lib.styled(Menu)`
  [class*="MuiPaper-root-"] {
    overflow: visible!important;
    border-radius: 10px!important;
    margin: 46px 0px 0px -13px!important;
  }

  div > ul {
    overflow: visible!important;
    padding: 0px!important;
    display: flex;
    border-radius: 10px;
    flex-direction: column;

    &::before{
      content: '';
      position: absolute;
      top: -20px;
      right: 10px;
      border-bottom: 10px solid ${colors.white};
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      border-top: 10px solid transparent;
      z-index: 10;
    }

    li {
      display: flex;
      height: 45px;
      padding: 0px 5px 0px 10px!important;

      &:focus {
        background-color: transparent!important;
      }

      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;

        &:nth-child(2) {
          border-top: 1px solid ${colors.lightGray06};
        }

        &:last-child {
          border-bottom: 0;
        }

        .left {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          line-height: 18px;

          span:first-child {
            font-size: ${fonts.label}px;
            color: ${colors.black};
            opacity: 0.5;
          }
          span:last-child {
            font-size: ${fonts.default}px;
            color: ${colors.black};

            img {
              margin-right: 2px;
              max-width: 12px;
            }
          }
        }

        .right {
          button {
            padding: 0px!important;
            min-width: 40px!important;
            height: 40px!important;
            display: flex;
            align-items: center;
            justify-content: center;

            .call-icon {
              width: 26px!important;
              height: 26px!important;
            }
          }
        }
      }
    }
  }
`;

export const MenuItemComponent = lib.styled(MenuItem)`
  .call-icon {
    ellipse {
      fill: ${props =>
        props.disabled ? colors.lightGray02 : colors.green02}!important;
    }
  }
`;

export const ButtonField = lib.styled(Button)`
  border-radius: 50%!important;
  min-width: 5px!important;
`;

export const DivRow = lib.styled.div`
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  min-height: 48px;
  margin-bottom: 5px;

  .transfer-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .call-transfer {
      width: 80px!important;
      height: 26px!important;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid ${colors.lightGray06};
      background-color: ${colors.white02};
      border-radius: 30px;
      padding: 0px;
      cursor: pointer;
      &:hover {
        background-color: ${colors.lightGray11};
      }

      &:last-child {
        margin-left: 5px;
      }
    }
    .txt-transfer {
      font-size: ${fonts.label}px!important;
      color: ${colors.black};
      font-weight: 600;
      opacity: 0.5;
      margin-left: 5px;
    }
  }
`;

export const BarDotted = lib.styled.div`
  border-top: ${props =>
    props.border ? `1px dotted ${colors.lightGray06}` : '0'};
  height: 1px;
  width: 100%;
`;

export const Row = lib.styled.div`
display: flex;
flex-direction: row;
min-height: 48px;
align-items: center;
justify-content: space-between;
background-color: ${props =>
  props.selectContact ? 'transparent' : colors.white02};
border-radius: ${props => (props.border ? '10px 10px 0px 0px' : '10px')};
padding-left: 9px;
padding-right: 9px;

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    img {
      width: 10px;
      height: 8px;
      margin-right: 4px;
    }

    span {
      font-size: 11px;
      opacity: 0.5;
    }
  }
  .number {
    font-size: 13px;
    color: ${colors.black};
  }
}

.actions {
  button {
    padding: 0px!important;
    min-width: 26px!important;
    height: 26px!important;
    display: flex;
    align-items: center;
    justify-content: center;

    .call-icon {
      width: 26px!important;
      height: 26px!important;
    }
  }
}
`;

export const IconButtonComponent = lib.styled(IconButton)``;

export const NameNumber = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const BoxData = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  .avatar {
    width: 37px;
    height: 37px;
    font-size: 10px;
    margin-right: 5px;
    border: 1.8px solid ${colors.white};
    background-color: ${colors.lightGray10};

    span {
      font-size: 12px;
      color: ${colors.black};
      opacity: 0.2;
    }
  }

  .TextMain{
    font-size: 13px;
    color: ${colors.black};
  }
`;
